// extracted by mini-css-extract-plugin
export default {"container":"Faq_container__mo7Yc","card":"Faq_card__pQnZS","title":"Faq_title__5K96l"};